import type { WorkerManager } from '../../../../worker';
import type { FilletFeatureDefinitionModel } from '../../../definition/fillet/FilletFeatureDefinition';
import type { FeatureEditSession } from '../../../edit/FeatureEditSession';
import { FeaturePreviewExecution } from '../FeaturePreviewExecution';

/**
 * 圆角特征预览执行器。
 */
export class FilletPreviewExecution extends FeaturePreviewExecution<FilletFeatureDefinitionModel> {
    /** Worker 管理器。 */
    private readonly workerManager: WorkerManager;

    /**
     * @param workerManager Worker 管理器。
     */
    public constructor(workerManager: WorkerManager) {
        super();
        this.workerManager = workerManager;
    }

    /**
     * @inheritdoc
     */
    public async executeCreatePreview(definition: FilletFeatureDefinitionModel): Promise<WorkerFeaturePreviewResult> {
        return this.workerManager.generateFilletPreview(definition.getCommandParams());
    }

    /**
     * @inheritdoc
     */
    public async executeEditPreview(
        session: FeatureEditSession<FilletFeatureDefinitionModel>,
        definition: FilletFeatureDefinitionModel,
    ): Promise<WorkerFeaturePreviewResult> {
        return this.workerManager.generateFilletPreviewInSandbox({
            commands: session.getPreviewCommands(),
            params: definition.getCommandParams(),
        });
    }
}
